import { SignupState } from "../../../../reducers/signup.reducer.types";

export const getFarmName = (state: SignupState) => state.api.eagriAuth.farmName;
export const getIsAuthenticated = (state: SignupState) =>
  state.api.eagriAuth.isEagriAuthenticated;
